module.exports = __webpack_public_path__ + "img/dance.d37d2246.svg";